import type { RawWorkout, Workout } from './types'

export default function parse(rawWorkout: RawWorkout): Workout {
  const { id, wodHtml, topicId } = rawWorkout

  return {
    htmlContent: wodHtml,
    slug: id.substr(-6),
    topicId,
  }
}
